import { render, staticRenderFns } from "./ConfigurationForm125.vue?vue&type=template&id=c5531f20&scoped=true&lang=pug&"
import script from "./ConfigurationForm125.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm125.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm125.vue?vue&type=style&index=0&id=c5531f20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5531f20",
  null
  
)

export default component.exports